import styled from "styled-components";

export const HeaderWrapper = styled.div<{
  inset: number | null;
  show: boolean;
  imgSize?: string;
}>`
  position: fixed;
  max-width: 500px;
  z-index: 10;
  left: 50%;
  transform: translateX(-50%);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: ${(props) => (props.show ? "translate" : "#fff")};
  font-size: 16px;
  font-weight: 600;
  top: 0;
  ${(p) => (p.inset ? `padding-top: ${p.inset + 22}px;` : "")}
  ${(p) => (p.inset ? `padding-bottom: 20px;` : "")}
  width: 100%;
  max-height: 48px;

  > .button {
    > img {
      width: ${(props) => (props.imgSize ? props.imgSize : "24px")};
      height: ${(props) => (props.imgSize ? props.imgSize : "24px")};
    }
  }
`;

export const HeaderTitle = styled.div<{
  show: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  > img {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }

  > .name {
    color: ${(props) => (props.show ? "#fff" : "#444444")};
    transition: all 0.1s ease-in-out;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
